import React from "react";
import { withRouter } from "react-router";
import $ from "jquery";

//helper
import { cleaner } from "./../../utils/helper";

//components
import LayoutSteps from "../Shared/LayoutSteps";

//css
import "./style.scss";

//config
import config from "./../../utils/const";

class Payment extends React.Component {
  constructor(props) {
    super(props);

    this.donate = this.props.state.donate;

    //Homolog
    // this.ausr = "ti_api1.vorttex.com.br";
    // this.apw = "QAPTFYM73AV45JV6";
    // this.asig = "Azef7iUT-X73WqDJ2oSubJwDySXDAJzN4I6mDd-yz.wZlqYOLtdGaxar";

    //PROD
    this.ausr = "apoie_api1.institutopeninsula.org.br";
    this.apw = "9V7C25GF298FFVJT";
    this.asig = "AGRdIuVgHn24E7bN-oVkzi8UOGiNAVMP7LVEZ3i2aBmsQCNTCZy1zSGt";

    // Configs
    this.state = {
      loaded: true,
      acTk: "",
      urlApproval: "",
      urlExecute: "",
      valorDoacao: this.donate.amount,
      period: this.donate.period,
      payerID: "",
      //paymentID : "",
      //intervalIframe : {},
      //dev
      //clId: "AXU_VBHYpsDLVNMNlrXUPoF9PBuV6FiJdRqORfm1C4tH18Lji6lg3hC_ZuHyQ0rw7tJ5OoAsd-xVdDrU",
      //sct: "EPxru1VTt7z8Q-ldNbJ4ch2kwWJSeUKQ_AXl1oSDY-tgzBQtwzK-q6Y15lnzNH-T17bl1ktIUQfOKZmR"
      //urlApi: "https://api.sandbox.paypal.com",
      //prod
      clId: "AcZukFuAwi39tK7_a-y4bmPtUt-g2ejxzXwaDwpjBCx1xMSEM7ghTZv73iWVbU0DVvSkRZisWFpksXEI",
      sct: "EBfyD9khrFhOG80rArYXG6Wn5n1-_Zb-qVn0wkrY7_Ne1DM2cWH4UktEUfEx0MTg0e0HXbkH5zLRiTNX",
      urlApi: "https://api.paypal.com"
    };
    this.ppp = {};
  }

  componentWillMount = () => {
    if (window.addEventListener) {
      window.addEventListener("message", this.receiveMessage, false);
      console.log("addEventListener successful", "debug");
    } else if (window.attachEvent) {
      window.attachEvent("onmessage", this.receiveMessage);
      console.log("attachEvent successful", "debug");
    } else {
      console.log("Could not attach message listener", "debug");
      throw new Error("Can't attach message listener");
    }

    this.props.actions.setProgressConfig(true, "100%", "5/5", "80%");

    this.getAccessTokenPPP();
  };

  componentDidMount = () => {
    if (this.donate.frequency === "once") {
      this.requestPaymentPPP(true);
    } else {
      this.requestRecurringPaymentPPP();
    }
  };

  loadIframePPP = () => {
    this.ppp = window.PAYPAL.apps.PPP({
      approvalUrl: this.state.urlApproval,
      placeholder: "ppplusDiv",
      //mode: "sandbox", //dev
      mode: "live", //prod
      payerFirstName: this.donate.profile === "pf" ? this.donate.firstName : this.donate.razaoSocial,
      payerLastName: this.donate.profile === "pf" ? this.donate.surname : this.donate.razaoSocial,
      payerEmail: this.donate.email,
      payerPhone: this.donate.phone,
      payerTaxId: cleaner(this.donate.profile === "pf" ? this.donate.cpf : this.donate.cnpj),
      //payerTaxIdType: (tipodoador === 'pj' ? 'BR_CNPJ' : 'BR_CPF'),
      payerTaxIdType: this.donate.profile === "pf" ? "BR_CPF" : "BR_CNPJ",
      language: "pt_BR",
      country: "BR",
      enableContinue: "continueButton",
      disableContinue: "continueButton"
    });
    console.log(this.app);
  };

  getAccessTokenPPP = () => {
    var that = this;
    var cli = this.state.clId;
    var secret = this.state.sct;
    $.ajax({
      type: "POST",
      async: false,
      url: this.state.urlApi + "/v1/oauth2/token?grant_type=client_credentials",
      beforeSend: function(request) {
        request.setRequestHeader("Accept", "application/json");
        request.setRequestHeader("Authorization", "Basic " + btoa(cli + ":" + secret));
      },
      success: function(data) {
        that.setState({ acTk: data.access_token });
      },
      error: function(data, jqXHR, exception) {
        console.log(data);
        //alert(data.status + jqXHR + exception);
      }
    });
  };

  requestPaymentPPP = loadIframe => {
    var valor = this.props.state.donate.amount;
    var dt = new Date();
    var objPayment = {
      intent: "sale",
      payer: {
        payment_method: "paypal"
      },
      application_context: {
        brand_name: "Instituto Península",
        shipping_preference: "NO_SHIPPING"
      },
      transactions: [
        {
          amount: {
            currency: "BRL",
            total: "" + valor,
            details: {
              shipping: "0",
              subtotal: "" + valor
            }
          },
          description: "Doação no site do Instituto",
          payment_options: {
            allowed_payment_method: "IMMEDIATE_PAY"
          },
          invoice_number: "" + dt.getTime(),
          item_list: {
            items: [
              {
                name: "Doação",
                description: "Doação para o Instituto Península",
                quantity: "1",
                price: "" + valor,
                sku: "doacao1",
                currency: "BRL"
              }
            ]
          }
        }
      ],
      redirect_urls: {
        return_url: "http://www2.institutopeninsula.org.br/_newapoie",
        cancel_url: "http://www2.institutopeninsula.org.br/_newapoie"
      }
    };

    var that = this;
    $.ajax({
      type: "POST",
      url: this.state.urlApi + "/v1/payments/payment",
      data: JSON.stringify(objPayment),
      beforeSend: function(request) {
        request.setRequestHeader("Content-Type", "application/json");
        request.setRequestHeader("Authorization", "Bearer " + that.state.acTk);
      },
      success: function(data) {
        for (var i = 0; i < data.links.length; i++) {
          if (data.links[i].rel === "approval_url") {
            that.setState({ urlApproval: data.links[i].href });
          }

          if (data.links[i].rel === "execute") {
            that.setState({ urlExecute: data.links[i].href });
          }
        }

        if (loadIframe) that.loadIframePPP();
      },
      error: function(data, jqXHR, exception) {
        console.log(data);
        //alert(data.status + jqXHR + exception);
      }
    });
  };

  getPlan = installments => {
    // Planos:
    // Homolog:
    // 6 - P-56Y35170VS760573TLUXYREA
    // 12 - P-36806361F06462325LUXYRUQ
    // 24 - P-49L40313BV455790MLUXYR2Q
    // 36 - P-4CH50590A84361045LUXYSDA

    // Prod:
    // 6  - P-8EW852685R835660TLUXYTGY
    // 12 - P-4XL00126XG866692CLUXYTJQ
    // 24 - P-3T289203DH675034ULUXYTMI
    // 36 - P-9L749804NP0846648LUXYTPA

    var plansProd = {
      "6": "P-8EW852685R835660TLUXYTGY",
      "12": "P-4XL00126XG866692CLUXYTJQ",
      "24": "P-3T289203DH675034ULUXYTMI",
      "36": "P-9L749804NP0846648LUXYTPA"
    };
    var plansHomolog = {
      "6": "P-56Y35170VS760573TLUXYREA",
      "12": "P-36806361F06462325LUXYRUQ",
      "24": "P-49L40313BV455790MLUXYR2Q",
      "36": "P-4CH50590A84361045LUXYSDA"
    };

    if (this.state.urlApi.indexOf("sandbox") > -1) return plansHomolog[this.donate.installments];
    else return plansProd[this.donate.installments];
  };

  requestRecurringPaymentPPP = loadIframe => {
    var valor = this.donate.amount;
    var dt = new Date();
    dt.setDate(dt.getDate() + 1);

    var objPayment = {
      plan_id: this.getPlan(this.donate.installments),
      start_time: dt,
      quantity: "" + valor,
      subscriber: {
        name: {
          given_name: this.donate.profile === "pf" ? this.donate.firstName : this.donate.razaoSocial,
          surname: this.donate.profile === "pf" ? this.donate.surname : ""
        },
        email_address: this.donate.email
      },
      auto_renewal: false,
      application_context: {
        brand_name: "Instítuto Península - Apoie",
        locale: "pt-BR",
        user_action: "SUBSCRIBE_NOW",
        payment_method: {
          payer_selected: "PAYPAL",
          payee_preferred: "IMMEDIATE_PAYMENT_REQUIRED"
        },
        return_url: "https://www.institutopeninsula.org.br/apoie",
        cancel_url: "https://www.institutopeninsula.org.br/apoie"
      }
    };

    var that = this;
    $.ajax({
      type: "POST",
      url: this.state.urlApi + "/v1/billing/subscriptions",
      data: JSON.stringify(objPayment),
      beforeSend: function(request) {
        request.setRequestHeader("Accept", "application/json");
        request.setRequestHeader("Content-Type", "application/json");
        request.setRequestHeader("Authorization", "Bearer " + that.state.acTk);
        request.setRequestHeader("Prefer", "return=representation");
      },
      success: function(data) {
        var found = false;
        for (var i = 0; i < data.links.length; i++) {
          if (data.links[i].rel === "approve") {
            found = true;
            window.location.href = data.links[i].href;
          }
        }

        if (!found) alert("Erro ao processar, tente novamente!");
      },
      error: function(data, jqXHR, exception) {
        console.log(data);
        //alert(data.status + jqXHR + exception);
      }
    });
  };

  receiveMessage = event => {
    try {
      console.log("receiveMessage", event.data);
      var message = JSON.parse(event.data);
      if (message["action"] === "loaded") {
        this.setState({ loaded: false });
      }

      if (typeof message["cause"] !== "undefined") {
        //iFrame error handling
        var ppplusError = message["cause"].replace(/['"]+/g, ""); //log & attach this error into the order if possible
        // <<Insert Code Here>>

        switch (ppplusError) {
          case "INTERNAL_SERVICE_ERROR": //javascript fallthrough
          case "SOCKET_HANG_UP": //javascript fallthrough
          case "socket hang up": //javascript fallthrough
          case "connect ECONNREFUSED": //javascript fallthrough
          case "connect ETIMEDOUT": //javascript fallthrough
          case "UNKNOWN_INTERNAL_ERROR": //javascript fallthrough
          case "fiWalletLifecycle_unknown_error": //javascript fallthrough
          case "Failed to decrypt term info": //javascript fallthrough
          case "RESOURCE_NOT_FOUND": //javascript fallthrough
          case "INTERNAL_SERVER_ERROR":
            this.requestPaymentPPP();
            alert("Ocorreu um erro inesperado, por favor tente novamente."); //pt_BR
            //Generic error, inform the customer to try again; generate a new approval_url andnreload the iFrame.
            setTimeout(function() {
              this.loadIframePPP();
            }, 700);
            break;
          case "RISK_N_DECLINE": //javascript fallthrough
          case "NO_VALID_FUNDING_SOURCE_OR_RISK_REFUSED": //javascript fallthrough
          case "TRY_ANOTHER_CARD": //javascript fallthrough
          case "NO_VALID_FUNDING_INSTRUMENT":
            this.requestPaymentPPP();
            alert("Seu pagamento não foi aprovado. Por favor utilize outro cartão, caso o problema persista entre em contato com o PayPal (0800-047-4482)."); //pt_BR
            //Risk denial, inform the customer to try again; generate a new approval_url and reload the iFrame.
            setTimeout(function() {
              this.loadIframePPP();
            }, 700);
            break;
          case "CARD_ATTEMPT_INVALID":
            this.requestPaymentPPP();
            alert("Ocorreu um erro inesperado, por favor tente novamente."); //pt_BR
            //03 maximum payment attempts with error, inform the customer to try again; generate a new approval_url and reload the iFrame.
            setTimeout(function() {
              this.loadIframePPP();
            }, 700);
            break;
          case "INVALID_OR_EXPIRED_TOKEN":
            this.requestPaymentPPP();
            alert("A sua sessão expirou, por favor tente novamente."); //pt_BR
            //User session is expired, inform the customer to try again; generate a new approval_url and reload the iFrame.
            setTimeout(function() {
              this.loadIframePPP();
            }, 700);
            break;
          case "CHECK_ENTRY":
            alert("Por favor revise os dados de cartão de Crédito inseridos."); //pt_BR
            //hideLoading();
            //Missing or invalid credit card information, inform your customer to check the inputs.
            // <<Insert Code Here>>
            break;
          default:
            //unknown error & reload payment flow
            this.requestPaymentPPP();
            alert("Ocorreu um erro inesperado, por favor tente novamente."); //pt_BR
            window.location.href = config.url;
          //Generic error, inform the customer to try again; generate a new approval_url and reload the iFrame.
          // setTimeout(function() {
          //   this.loadIframePPP();
          // }, 700);
        }
      }

      if (message["action"] === "checkout") {
        //PPPlus session approved, do logic
        var rememberedCard = null;
        var installmentsValue = null;
        rememberedCard = message["result"]["rememberedCards"]; //save on user BD record
        this.setState({ payerID: message["result"]["payer"]["payer_info"]["payer_id"] }); //use it on executePayment API

        if ("term" in message) {
          installmentsValue = message["result"]["term"]["term"]; //installments value
        } else {
          installmentsValue = 1; //no installments
        }

        this.executePaymentPPP();
      }
    } catch (e) {
      //treat exceptions here
      // <<Insert Code Here>>
    }
  };

  executePaymentPPP = () => {
    var objAPI = {};
    var that = this;
    objAPI.payer_id = this.state.payerID;

    $.ajax({
      type: "POST",
      url: this.state.urlExecute,
      data: JSON.stringify(objAPI),
      beforeSend: function(request) {
        request.setRequestHeader("Content-Type", "application/json");
        request.setRequestHeader("Authorization", "Bearer " + that.state.acTk);
      },
      success: function(data) {
        //GAUnico
        if (window.dataLayer) {
          window.dataLayer.push({
            ecommerce: {
              purchase: {
                actionField: {
                  id: "Unico",
                  affiliation: "Instituto Península",
                  revenue: that.state.valorDoacao,
                  currency: "BRL"
                }
              }
            },
            event: "Doacao"
          });
        }
        that.props.history.push(`${config.url}educacao/thankyou`);
      },
      error: function(data, jqXHR, exception) {
        console.log(data);
        if (data.status === 400) {
          var obj = JSON.parse(data.responseText);
          if (obj.name === "INTERNAL_SERVICE_ERROR") {
            this.executePaymentPPP();
          } else {
            if (obj.name === "INSTRUMENT_DECLINED") {
              alert("Seu pagamento não foi aprovado pelo banco. Verifique a situação do cartão.");
            } else {
              alert("Seu pagamento não foi aceito pelo PayPal pelo seguinte motivo: \n\n" + obj.name + " - " + obj.message);
            }
            window.location.href = config.url;

            // setTimeout(function () {
            //     location.reload();
            // }, 500);
          }
        } else {
          alert("Houve um erro para finalizar seu pagamento.\n\nTente novamente mais tarde.");
        }
      }
    });
  };

  submitForm = e => {
    e.preventDefault();
    //validate
    this.setMsg([]);
    this.setSubmited(true);
  };

  render = () => {
    return (
      <LayoutSteps
        className="wrapper-payment"
        renderButtom={() => (
          <button
            className="btn-donation btn-donation--green btn-donation--white button"
            id="continueButton"
            onClick={() => {
              this.ppp.doContinue();
              return false;
            }}
          >{`Pagar R$${this.state.period > 0 ? this.state.period * this.state.valorDoacao : this.state.valorDoacao}`}</button>
        )}
      >
        <div className="container text-center">
          {this.state.loaded && <img className="ImgLoad" src={`${config.pathImages}ImgLoad.gif`} alt="loading..." />}
          <div id="ppplusDiv" />
        </div>
      </LayoutSteps>
    );
  };
}

export default withRouter(Payment);
